import { render, staticRenderFns } from "./DashboardPatients.vue?vue&type=template&id=635c97aa"
import script from "./DashboardPatients.vue?vue&type=script&lang=js"
export * from "./DashboardPatients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports